module.exports = __webpack_public_path__ + "fonts/FuturaPT-Light.5fa9ee1c.woff2";